import React, { useEffect } from 'react';
import { string } from 'prop-types';
import {
  params,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import ReactHtmlParser from 'react-html-parser';
import styles from './article-section.module.scss';

const Outro = ({ articleGUID }) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('author-title.ready'); }, []);

  const { data, loading, error } = useDataModel('article', {
    variables: { articleGUID }
  });

  if (!data || loading || error) return null;

  const outro = data?.article?.outro;

  if (!outro) return null;

  return (
    <div data-testid="outro" className={styles['article-sections__outro']}>
      {ReactHtmlParser(outro)}
    </div>
  );
};

Outro.displayName = 'Outro';

Outro.dataModel = {
  article: params({ articleGUID: stringType().isRequired() }).shape({
    outro: stringType()
  }),
};

Outro.propTypes = {
  articleGUID: string.isRequired
};

export { Outro };
